<odx-icon name="chevron-up" class=" ml-7" *ngIf="columnSorted?.order === 1 && columnSorted?.field === columnName"></odx-icon>

<odx-icon name="chevron-down" class="ml-7" *ngIf="columnSorted?.order === -1 && columnSorted?.field === columnName"></odx-icon>

<odx-icon class=" ml-7" name="chevron-down" *ngIf="columnSorted?.field !== columnName"></odx-icon>
